import React from 'react';
import {appLanguage, WEBSITE_TYPE} from "../../../config/Constants";
import TermsAndConditionsPlainContentNL from "./TermsAndConditionsPlainContentNL";
import TermsAndConditionsPlainContentBE from "./TermsAndConditionsPlainContentBE";

export default function TermsAndConditionsPlainContent() {

    return (
        <>
            {WEBSITE_TYPE === appLanguage.nl ? (
                <TermsAndConditionsPlainContentNL />
            ) : (
                <TermsAndConditionsPlainContentBE />
            )}
        </>
    );
}


